import { render, staticRenderFns } from "./Parceria_Fettrominas_Base_Metropolitana_Setcemg.vue?vue&type=template&id=04c450bc"
import script from "./Parceria_Fettrominas_Base_Metropolitana_Setcemg.vue?vue&type=script&lang=js"
export * from "./Parceria_Fettrominas_Base_Metropolitana_Setcemg.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Fettrominas_Base_Metropolitana_Setcemg.vue?vue&type=style&index=0&id=04c450bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports